angular.module('app')
  .directive('mediathequeMultivaluedContributionIllustrationInput', MultivaluedContributionIllustrationInputDirective);

function MultivaluedContributionIllustrationInputDirective() {
  return {
    restrict: 'E',
    scope: {
      name: '@mediathequeName',
      id: '@mediathequeId',
      addElementTitle: '@mediathequeAddElementTitle',
      removeElementTitle: '@mediathequeRemoveElementTitle',
      illustrationId: '@mediathequeIllustrationId',
      form: '@mediathequeForm',
      disabled: '&mediathequeDisabled',
      withReproduction: '&mediathequeWithReproduction',
      initialValues: '&mediathequeInitialValues'
    },
    replace: true,
    controller: MultivaluedContributionIllustrationInputController,
    controllerAs: 'inputsCtrl',
    templateUrl: 'common/multivalued-contribution-illustration-input.html'
  };
}

/*@ngInject*/
function MultivaluedContributionIllustrationInputController($scope) {
  var inputsCtrl = this;

  inputsCtrl.addContribution = addContribution;
  inputsCtrl.removeContribution = removeContribution;

  init();

  // TODO: Ajouter un watcher sur $scope.model (couplé à un $timeout pour s'assurer que le scope est bien à jour)
  // si le model initial est modifié par le composant parent

  function addContribution() {
    inputsCtrl.contributions.push({ libelle: "" });
    inputsCtrl.dirty = true;
    inputsCtrl.newlyAdded = true;
  }

  function removeContribution(contributionToRemove) {
    inputsCtrl.contributions = _.without(inputsCtrl.contributions, contributionToRemove);

    // Il faut au moins un champs affiché
    if (inputsCtrl.contributions.length === 0) {
      inputsCtrl.contributions = [{ qualites: [{ libelle: ""}], auteurId: null }];
    }
    inputsCtrl.dirty = true;
    inputsCtrl.newlyAdded = false;
  }

  function init() {
    inputsCtrl.contributions = ($scope.initialValues() && $scope.initialValues().length !== 0) ? $scope.initialValues() : [{ qualites: [{ libelle: ""}], auteurId: null }];
    inputsCtrl.dirty = false;
    inputsCtrl.newlyAdded = false;
  }
}
